import * as React from "react";
import { InputOptionalInfo, FormikFormGroup } from "components/common";
const DescriptionFormGroup = ({ wrapperClassName = void 0, labelClassName = void 0 }) => /* @__PURE__ */ React.createElement(
  FormikFormGroup,
  {
    name: "description",
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Description ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
    type: "textarea",
    labelClassName,
    wrapperClassName,
    help: "Clarify the purpose of this filter in detail. Especially useful when sharing the filter with others."
  }
);
export default DescriptionFormGroup;
